import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

const page12 = {
  defaultNextPage: 'page-13',
  content: [
    configureProgressBar(77),
    configureTitle(['How long have you had this account?']),
    {
      component: ButtonGroup,
      name: 'bankAccountAge',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'bankAccountAge',
        direction: 'column',
        options: [
          {
            displayValue: 'Less than a month',
            id: 'bankAccountAge0',
            value: '1'
          },
          {
            displayValue: '1 to 5 months',
            id: 'bankAccountAge3',
            value: '3'
          },
          {
            displayValue: '6 to 11 months',
            id: 'bankAccountAge9',
            value: '9'
          },
          {
            displayValue: '1 to 4 years',
            id: 'bankAccountAge24',
            value: '24'
          },
          {
            displayValue: 'More than 4 years',
            id: 'bankAccountAge60',
            value: '60'
          }
        ]
      }
    },
    nextButtonConfig('page-12')
  ]
};

export default page12;
